import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import Select from 'react-select'

import { httpOk, GET, POST, PUT } from 'helpers/api'
import HintIcon from 'pages/parts/HintIcon'

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState({
		'id': "",
		'name': "",
		'order_types': [],
	})
	const [paymentTypes, setPaymentTypes] = useState([])
	const [deliveryRules, setDeliveryRules] = useState([])
	const [orderTypeSubs, setOrderTypeSubs] = useState([])
	const [externalMenus, setExternalMenus] = useState([])
	const [priceCategories, setPriceCategories] = useState([])

	async function searchWithFilter() {
		var filterUrl = `/chain/call-center`

		var response = await GET(filterUrl, {}, { loader: true })

		var responseOrderTypes = await GET('/helper/order-types')
		if (httpOk(response) && httpOk(responseOrderTypes) && !response.data.id) {
			response.data.order_types = responseOrderTypes.data

			setData(response.data);
		}

		if (httpOk(response) && response.data.id) setData(response.data);
	}

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (data.id) {
			response = await PUT('/chain/call-center', data, { loader: true })
		} else {
			response = await POST('/chain/call-center', data, { loader: true })
			if (httpOk(response)) searchWithFilter()
		}

		if (httpOk(response)) { }
	}

	function handleSettingChange(e, item, index) {
		var dataCopy = { ...data }

		dataCopy['poses'][index]['status'] = e.target.checked
		setData(dataCopy)
	}

	function handleSelectOrderTypeSub(option, index) {
		var dataCopy = { ...data }

		dataCopy['order_types'][index]['order_type_sub_id'] = option.id
		setData(dataCopy)
	}

	async function getPaymentTypes() {
		const response = await GET('/helper/payment-types')
		if (httpOk(response)) setPaymentTypes(response.data)
	}

	async function getDeliveryRules() {
		const response = await GET('/helper/delivery-rules')
		if (httpOk(response)) setDeliveryRules(response.data)
	}

	async function getOrderTypeSubs() {
		const response = await GET('/helper/order-type-subs')
		if (httpOk(response)) setOrderTypeSubs(response.data)
	}

	async function getExternalMenus() {
		const response = await GET('/helper/external-menu')
		if (httpOk(response)) setExternalMenus(response.data ?? [])
	}

	async function getPriceCategories() {
		const response = await GET('/price-categories')
		if (httpOk(response)) setPriceCategories(response.data?.data ?? [])
	}

	useEffect(() => {
		searchWithFilter()
		getPaymentTypes()
		getDeliveryRules()
		getOrderTypeSubs()
		getExternalMenus()
		getPriceCategories()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const menuOptions = [
		{ id: null, name: t('main_menu') },
		...externalMenus,
	]
	const selectedMenuOption = data.external_menu_id
		? menuOptions.find(option => Number(option.id) === Number(data.external_menu_id))
		: menuOptions[0]

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('call_center')}
					</h4>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="row">
						<div className="col-md-8">
							<div className="form-group">
								<label>{t('name2')}<span className="required-mark">*</span></label>
								<input type="text" className="form-control" name="name"
									autoComplete="off"
									value={data.name ?? ''}
									onChange={(e) => setData({ ...data, 'name': e.target.value })} />
							</div>
							<hr />

							<label>{t('delivery_type')}<span className="required-mark">*</span></label>
							<div className="d-flex flex-column gap-2">
								{data?.order_types.map((item, index) => (
									<div key={index} className="d-flex justify-content-between">
										<p className="fw-600 vertical-center">{item.name}</p>
										<Select
											className="w-50"
											options={orderTypeSubs}
											value={orderTypeSubs.find(option => option.id === item.order_type_sub_id) || ''}
											onChange={(option) => handleSelectOrderTypeSub(option, index)}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.id}
										/>
									</div>
								))}
							</div>

							<hr />
							<div className="form-group w-100">
								<label>{t('payment_types')}<span className="required-mark">*</span></label>
								<Select
									isMulti
									options={paymentTypes}
									value={data.payment_types}
									onChange={(options) => setData({ ...data, 'payment_types': options })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
							
							<div className="form-group w-100">
								<label>{t('default')}<span className="required-mark">*</span></label>
								<Select
									options={paymentTypes}
									value={paymentTypes.find(option => option.payment_type_id === data.payment_type_id) || ''}
									onChange={(option) => setData({ ...data, 'payment_type_id': option.payment_type_id })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.payment_type_id}
								/>
							</div>

							<div className="form-group w-100">
								<label>{t('order_types')} - ({t('reports')})<span className="required-mark">*</span></label>
								<Select
									isMulti
									options={orderTypeSubs}
									value={data.order_type_subs}
									onChange={(options) => setData({ ...data, 'order_type_subs': options })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>

							{/* Витрина колл-центра по умолчанию: оператор может переключить меню в заказе */}
							<div className="form-group w-100">
								<label>{t('external_menu')}</label>
								<Select
									options={menuOptions}
									value={selectedMenuOption || null}
									onChange={(option) => setData({ ...data, 'external_menu_id': option?.id ?? null })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id ?? 'main'}
								/>
							</div>

							<div className="form-group w-100">
								<label>{t('price_category')}<HintIcon text={t('channel_price_category_hint')} /></label>
								<Select
									isClearable
									options={priceCategories}
									value={priceCategories.find((option) => option.id === data.price_category_id) || ''}
									onChange={(option) => setData({ ...data, 'price_category_id': option ? option.id : null })}
									placeholder={t('base_price')}
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>

							<div className="form-group w-100">
								<label>{t('delivery_rules')}<span className="required-mark">*</span></label>
								<Select
									options={deliveryRules}
									value={deliveryRules.find(option => option.id === data.delivery_rule_id) || ''}
									onChange={(option) => setData({ ...data, 'delivery_rule_id': option ? option.id : null })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>

							<div className="d-flex justify-content-between mb-2">
								<div className="fw-500 vertical-center">
									{t('show_product_image')}
								</div>
								<div className="form-check form-switch form-switch-lg">
									<input type="checkbox" className="form-check-input"
										name="is_image_visible"
										checked={data.is_image_visible ? true : false}
										onChange={(e) => setData({ ...data, 'is_image_visible': e.target.checked })} />
								</div>
							</div>

							<div className="d-flex justify-content-between mb-2">
								<div className="fw-500 vertical-center">
									{t('is_send_location')}
								</div>
								<div className="form-check form-switch form-switch-lg">
									<input type="checkbox" className="form-check-input"
										name="is_send_location"
										checked={data.is_send_location ? true : false}
										onChange={(e) => setData({ ...data, 'is_send_location': e.target.checked })} />
								</div>
							</div>
						</div>

						<div className="col-md-6 d-none">
							<label>{t('poses')}</label>
							<div className="table-responsive">
								<table className="table table-bordered mb-0">
									<thead>
										<tr>
											<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
											<th style={{ 'width': '90%' }}>{t('name2')}</th>
											<th style={{ 'width': '10%' }}></th>
										</tr>
									</thead>
									<tbody>
										{data?.poses?.map((item, index) => (
											<tr key={index}>
												<td style={{ 'width': '33px' }} className="text-center">{index + 1}</td>
												<td>{item.name}</td>
												<td className="d-flex justify-content-end">
													<div className="form-check form-switch form-switch-sm">
														<input type="checkbox" className="form-check-input"
															checked={item.status ? true : false}
															onChange={(e) => handleSettingChange(e, item, index)} />
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					</div>

					<div className="btn-wrapper gap-2">
						<Link className="btn btn-warning btn-rounded btn-wide" to="/external-integrations">
							{t('cancel')}
						</Link>
						<button type="button" className="btn btn-primary btn-rounded btn-wide"
							onClick={(e) => createUpdate(e)}>
							{t('save')}
						</button>
					</div>
				</div>
			</div>
		</>
	)
}

export default Index